export function hexColorOpacity(hexColor: string, factor = 0.3) {
  const colorStr = hexColor.replace('#', '');
  let r = parseInt(colorStr.substring(0, 2), 16);
  let g = parseInt(colorStr.substring(2, 4), 16);
  let b = parseInt(colorStr.substring(4, 6), 16);

  r = Math.round(r + (255 - r) * factor);
  g = Math.round(g + (255 - g) * factor);
  b = Math.round(b + (255 - b) * factor);

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
